import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// CRA dev overlay treats this benign browser warning as a fatal error.
function isResizeObserverLoop(message) {
  if (message == null) return false;
  return /ResizeObserver loop/i.test(String(message));
}

function suppressResizeObserverLoop(event) {
  const msg =
    event?.message ||
    event?.error?.message ||
    (typeof event?.reason === 'string' ? event.reason : event?.reason?.message) ||
    '';
  if (!isResizeObserverLoop(msg)) return;

  event.stopImmediatePropagation?.();
  event.preventDefault?.();
}

window.addEventListener('error', suppressResizeObserverLoop, true);

window.addEventListener('unhandledrejection', (event) => {
  suppressResizeObserverLoop(event);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
